import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSettings } from '../api/client';
import PaymentLinkWizardModal from '../components/PaymentLinkWizardModal';

export default function CreatePayment() {
  const { t } = useTranslation();
  const [paymentLinksEnabled, setPaymentLinksEnabled] = useState(false);
  const [settingsLoaded, setSettingsLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    getSettings()
      .then((res) => {
        const data = res.data?.settings ?? res.data ?? {};
        if (active) setPaymentLinksEnabled(data.payment_links_enabled === true);
      })
      .catch(() => {
        if (active) setPaymentLinksEnabled(false);
      })
      .finally(() => {
        if (active) setSettingsLoaded(true);
      });
    return () => {
      active = false;
    };
  }, []);

  if (!settingsLoaded) {
    return <div className="text-sm text-gray-500">{t('common.loading')}</div>;
  }

  if (!paymentLinksEnabled) {
    return (
      <div className="mx-auto max-w-2xl rounded-lg border border-gray-200 bg-white p-6">
        <h1 className="text-xl font-semibold text-gray-900">{t('paymentLinkWizard.title')}</h1>
        <p className="mt-2 text-sm text-gray-500">
          {t('paymentLinks.disabledInSettings')}
        </p>
      </div>
    );
  }

  return <PaymentLinkWizardModal inline />;
}
